module.exports = __webpack_public_path__ + "2f22404009211e1bc983c5ec9f044a31.svg";